import {
    CacheConfig,
    Environment,
    Network,
    RecordSource,
    Store,
} from "relay-runtime";
import RelayQueryResponseCache from "relay-runtime/lib/network/RelayQueryResponseCache";
import { getApiUrl, getAppCode, getLocale } from "@/Redux/App/AppReducer";
import RelayModernEnvironment from "relay-runtime/lib/store/RelayModernEnvironment";
import { selectAuthToken } from "@/Redux/Auth/AuthReducer";
import { v4 as uuidv4 } from "uuid";

class RelayEnvironment {
    private relayCache: RelayQueryResponseCache;
    private authToken: string | null;
    private endpoint: string;
    private environment: RelayModernEnvironment | undefined;

    constructor() {
        this.relayCache = new RelayQueryResponseCache({
            size: 800,
            ttl: 60 * 1000,
        });

        this.init();

        this.endpoint = "";
        this.authToken = null;
    }

    init() {
        this.environment = new Environment({
            // @ts-ignore
            network: Network.create(this.query.bind(this)),
            store: new Store(new RecordSource(), {
                queryCacheExpirationTime: 1,
            }),
        });
    }

    getServerUrl() {
        return getApiUrl() + "" + this.endpoint;
    }

    getEnvironment(endpoint: string, token: string | null = null) {
        this.endpoint = "";
        this.authToken = token;
        return this.environment;
    }

    query(
        operation: { text: string; operationKind: string },
        variables: any,
        cacheConfig: CacheConfig,
    ) {
        const requestId = uuidv4();
        const queryID = operation.text;
        const isMutation = operation.operationKind === "mutation";
        const isQuery = operation.operationKind === "query";
        const forceFetch = cacheConfig && cacheConfig.force;

        //Try to get data from cache on queries
        const fromCache = this.relayCache.get(queryID, variables);
        if (isQuery && fromCache !== null && !forceFetch) {
            return fromCache;
        }

        const headers = {
            "Content-Type": "application/json",
            language: getLocale(),
            authcode: getAppCode(),
            requestId: requestId,
        };

        if (this.authToken !== null) {
            // @ts-ignore
            headers["Authorization"] = "Bearer " + this.authToken;
        }

        return fetch(this.getServerUrl(), {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                query: operation.text,
                variables: {
                    ...variables,
                },
            }),
        })
            .then((response) => {
                return response.text();
            })
            .then((text) => {
                return JSON.parse(text);
            })
            .then((json) => {
                if (!json.data && json.errors) {
                    throw Error(json.errors[0].message);
                }
                // Update cache on queries
                if (isQuery && json) {
                    this.relayCache.set(queryID, variables, json);
                }
                // Clear cache on mutations
                if (isMutation) {
                    this.relayCache.clear();
                }

                return json;
            });
    }
}

const AuthRelay = new RelayEnvironment();
export const relayAuthEnvironment = () => {
    const token = selectAuthToken();
    return AuthRelay.getEnvironment("auth", token);
};
export const relayGuestEnvironment = () => {
    return AuthRelay.getEnvironment("guest");
};
